export const userTypes = {
    SET_IS_LOADING_SINGLE_USER : "SET_IS_LOADING_SINGLE_USER"
}